import script from "./NoteAttachmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteAttachmentModal.vue?vue&type=script&setup=true&lang=js"

import "./NoteAttachmentModal.vue?vue&type=style&index=0&id=d51580b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d51580b2"]])

export default __exports__